// src/hooks/useCurrencyFormatter.js
import { useTranslation } from 'react-i18next';

export const useCurrencyFormatter = () => {
  const { i18n } = useTranslation();
  
  const formatCurrency = (value) => {
    const locale = i18n.language === 'fr' ? 'fr-CA' : 'en-CA';
    
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'CAD',
    }).format(value || 0);
  };
  
  return formatCurrency;
};